export default "__VITE_ASSET__53d3ab96__"